import { publish, subscribe } from '../patched-message-bus';
import { commandLanguageSelect, onEventLanguageRequested } from './message-bus-helpers';

export default (function () {
  subscribe(onEventLanguageRequested(function (_ref) {
    var code = _ref.code;

    publish(commandLanguageSelect(code));
  }));
});
//# sourceMappingURL=workflow.js.map